<div class="flex flex-col pt-2 pb-0 px-0 md:py-4 rounded-lg">
  <div>Primary Reporter</div>
  <div class="flex justify-start pt-2">
    <div
      class="rounded-full border border-blue-950 h-7 w-7 overflow-hidden transition-[border] duration-300 ease-in-out mr-2.5 hover:border-orange-500"
    >
      <span>
        <img
          class="max-h-full max-w-full pointer-events-none"
          alt="Reporter icon"
          src="assets/images/img_user_default@2x.png"
        />
      </span>
    </div>

    <div>
      <div class="flex text-base leading-4 pb-2">
        {{ ticket.Contact.Name | titlecase }}
        @if (ticket.Contact.Title) {
          <span
            class="pl-2 italic text-xs border-l border-[color:var(--black-blue)] ml-2"
          >
            {{ ticket.Contact.Title | titlecase }}
          </span>
        }
      </div>
      <div class="text-sm flex leading-2 items-center">
        <mat-icon class="text-sm">call</mat-icon>
        {{
          ticket.Contact.Phone !== null
            ? (ticket.Contact.Phone | phoneNumber: 'US')
            : 'N/A'
        }}
      </div>

      <div class="text-sm flex leading-2 items-center">
        <mat-icon class="text-sm">mail</mat-icon>
        {{ (ticket.Contact.Email | lowercase) || 'N/A' }}
      </div>
    </div>
  </div>
</div>
